import { render, staticRenderFns } from "./TotalVolume.vue?vue&type=template&id=02becb21&"
import script from "./TotalVolume.vue?vue&type=script&lang=js&"
export * from "./TotalVolume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports